import React, { useMemo } from 'react'
import { useVenti } from 'venti'
import { ModalPleaseWait } from './ModalPleaseWait'
import { getTheme } from '../../config'

const theme = getTheme()

const ModalAppPosting = () => {
	const ventiState = useVenti()
	const appPosting = useMemo(
		() => ventiState.get(theme.storageKeys.appPosting),
		[ventiState]
	)
	return (
		<ModalPleaseWait
			visible={appPosting}
			message="Please be patient while we prepare your application. Do not close this window, refresh the page or hit the back button on your browser."
		/>
	)
}

export default ModalAppPosting
